import React from 'react'
import { cnMerge } from '../../utils/twmerge'
import type { SimpleTextareaProps } from './types'

export const SimpleTextarea: React.FC<SimpleTextareaProps> = ({
  className,
  placeholder = "Digite seu texto...",
  value,
  onChange,
  disabled = false,
  rows = 4,
  label,
  description,
  error
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value)
  }

  return (
    <div className="flex flex-col gap-2">
      {/* Label */}
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}

      {/* Textarea */}
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={cnMerge(
          // Base styles
          'flex w-full rounded-md border border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100',
          // Placeholder styles
          'placeholder:text-gray-500 dark:placeholder:text-gray-400',
          // Focus styles
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/20 dark:focus-visible:ring-blue-400/20 focus-visible:border-blue-500 dark:focus-visible:border-blue-400',
          // Transition
          'transition-colors duration-200',
          // Disabled styles
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50 dark:disabled:bg-neutral-900',
          // Resize
          'resize-vertical',
          // Error state
          error && 'border-red-500 dark:border-red-600 focus-visible:border-red-500 dark:focus-visible:border-red-600 focus-visible:ring-red-500/20 dark:focus-visible:ring-red-600/20',
          className
        )}
      />

      {/* Description */}
      {description && !error && (
        <p className="text-xs text-gray-600 dark:text-gray-400">
          {description}
        </p>
      )}

      {/* Error */}
      {error && (
        <p className="text-xs text-red-600 dark:text-red-400">
          {error}
        </p>
      )}
    </div>
  )
}
